import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sd-arrow-angle-left-white",
  "use": "sd-arrow-angle-left-white-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"sd-arrow-angle-left-white\"><path d=\"M12.005 6.707a.5.5 0 10-.712-.702L5.586 12.01l5.707 5.995a.5.5 0 10.702-.712L7 12l5.005-5.293z\" fill=\"#fff\" /><path d=\"M14.395 17.541a1.498 1.498 0 002.158 0 1.597 1.597 0 000-2.216L13.316 12l3.237-3.325a1.597 1.597 0 000-2.216 1.498 1.498 0 00-2.158 0L9 12l5.395 5.541z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol